import { RewardsStore } from './rewards.store';

export const rewardsStore = new RewardsStore();